const TYPE_MAP = {
  '^js': 'javascript',
  '^ts': 'javascript',
  '^java': 'java',
  '^py': 'python',
  '^php': 'php',
  '^htm': 'html',
}

export const fileTypeOf = (fileName = '') => {
  const fileExt = fileName.split('.').pop()
  const key = Object.keys(TYPE_MAP).filter((key) => fileExt?.match(key))
  return TYPE_MAP[key[0] as keyof typeof TYPE_MAP] || 'html'
}
